function sort<T extends object, K extends keyof T>(list: T[], key: K, keys: T[K][]) {
  return list.sort((a, b) => {
    const index1 = keys.findIndex((_) => _ === a[key]);
    const index2 = keys.findIndex((_) => _ === b[key]);

    return index1 - index2;
  });
}

export default sort;
